import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MetadataProp } from 'src/app/models/metadata-prop-model';
import { MetadataService } from 'src/app/services/metadata.service';
import { ResultSelectionService } from 'src/app/services/result-selection.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reports-dialog',
  templateUrl: './reports-dialog.component.html',
  styleUrls: ['./reports-dialog.component.css']
})
export class ReportsDialogComponent implements OnInit {

  @Input() createReportVisible: boolean = false;
  @Output() closeDialog = new EventEmitter();
  @Output() executeDownload = new EventEmitter();
  props: MetadataProp[] = [];
  selectedProperties: MetadataProp[] = [];
  reportType: string = 'Excel';
  propertyOption: string = 'all';
  selectionInvalid = false;
  itemCount: number = 0;
  docMax: number = 0;

  constructor(private mdSvc: MetadataService, private selectionSvc: ResultSelectionService) {

  }

  ngOnInit(): void {
    this.props = this.mdSvc.getReportable();
    this.docMax = environment.results_max;
    this.selectionSvc.selectedCount$.subscribe(c => {this.itemCount = c;});
  }

  executeClose() {
    this.closeDialog.emit();
  }

  executeReport() {
    this.validateSelections();
    if (!this.selectionInvalid)
    {
      let options = {
        'fileType': this.reportType,
        'downloadType': this.propertyOption,
        'props': this.selectedProperties
      }
      this.executeDownload.emit(options);
    }
  }

  validateSelections() {
    if ((this.propertyOption !== 'all') && (this.selectedProperties.length < 1)) {
      this.selectionInvalid = true;
    }
    else {
      this.selectionInvalid = false;
    }
  }

  clearValidation() {
    this.selectionInvalid = false;
  }
}
